import React from 'react'
import PropTypes from 'prop-types'
import { GridColumn } from 'semantic-ui-react'
import RegisteredFormField from '../../../common/RegisteredFormField'
import ControlledFormField from '../../../common/ControlledFormField'

export const GROUP_NUMBER_TOOLTIP = 'The Group ID number for your employer will have eight characters, ' +
  'beginning with \'G000\' followed by four additional letters or numbers specific to your employer. ' +
  'If the group number is unknown, contact employer. If a new group, enter \'New\' in the Group ID number section.'

const GroupFields = ({ path, controlledState = {} }) => {
  const { state, onChange, onBlur } = controlledState

  const subgroupComponent = state ?
    <ControlledFormField
      id='subgroup'
      onChange={onChange}
      onBlur={onBlur}
      value={state.subgroup.value}
      label={<label htmlFor='subgroup'>Subgroup Number <small className='u-fontSmaller'>(if
        applicable)</small></label>}
      maxLength={4}
    /> :
    <RegisteredFormField
      id='subgroup'
      path={`${path}.subgroup`}
      label={<label htmlFor='subgroup'>Subgroup Number <small className='u-fontSmaller'>(if
        applicable)</small></label>}
      maxLength={4}
    />

  const groupNameComponent = state ?
    <ControlledFormField
      id='groupName'
      onChange={onChange}
      value={state.groupName.value}
      onBlur={onBlur}
      label='Group Name'
    /> :
    <RegisteredFormField
      id='groupName'
      path={`${path}.name`}
      label='Employer Name'
    />

  const groupNumberComponent = state ?
    <ControlledFormField
      id='groupNumber'
      attachedLabel='G000'
      label='Group ID Number'
      maxLength={4}
      value={state.groupNumber.value}
      error={state.groupNumber.error}
      onChange={onChange}
      onBlur={onBlur}
    /> :
    <RegisteredFormField
      id='groupNumber'
      path={`${path}.groupNumber`}
      attachedLabel='G000'
      label='Group ID Number'
      maxLength={4}
      transform={(v) => v.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()}
      hoverDetail={GROUP_NUMBER_TOOLTIP}
    />

  return <>
    <GridColumn computer={4} tablet={4} mobile={16}>
      {groupNumberComponent}
    </GridColumn>
    <GridColumn computer={8} tablet={8} mobile={16}>
      {subgroupComponent}
    </GridColumn>
    <GridColumn width={16}>
      {groupNameComponent}
    </GridColumn>
  </>
}

GroupFields.propTypes = {
  /** The root path for these fields in the redux form object. */
  path: PropTypes.string,
  /**
   * A parent can pass a state object and its setter
   *  to control the values of the these fields from the parent
   *  instead of rendering fields connected to the redux store.
   */
  controlledState: PropTypes.exact({
    /** The state object */
    state: PropTypes.object,
    /** A function to call when setting the state object on changes */
    onChange: PropTypes.func,
    /** A function to call when setting the state object on blur */
    onBlur: PropTypes.func
  })
}

export default GroupFields